const addressFields = {
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    country: "short_name",
    postal_code: "short_name"
};

export const formatAddress = (address, cityOnly) => {
    let newAddress = {};

    if (!address || address.length === 0) {
        return "";
    }

    if (typeof address === "string") {
        return address;
    }

    if (typeof address === "object" && !address.city) {
        address.forEach(element => {
            if (element.types[0] in addressFields) {
                newAddress[element.types[0]] =
                    element[addressFields[element.types[0]]];
            }
        });
    } else {
        newAddress = address;
    }

    if (cityOnly) {
        return {
            postalCode: newAddress?.postal_code ?? "", // eslint-disable-line camelcase
            city: newAddress?.locality ?? ""
        };
    }

    return {
        country: newAddress?.country ?? "",
        street: newAddress?.route ?? "",
        houseNumber: newAddress?.street_number ?? "", // eslint-disable-line camelcase
        postalCode: newAddress?.postal_code ?? "", // eslint-disable-line camelcase
        city: newAddress?.locality ?? ""
    };
};
